// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgSearchLine = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="m12.02 11.078 2.856 2.855-.943.943-2.855-2.855a5.97 5.97 0 0 1-3.745 1.313c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.687 6 6a5.97 5.97 0 0 1-1.312 3.744m-1.337-.495a4.665 4.665 0 0 0-3.35-7.917 4.665 4.665 0 0 0-4.666 4.667 4.665 4.665 0 0 0 7.916 3.35z"
    />
  </svg>
);
export const SearchLineIcon = forwardRef(SvgSearchLine);
